/**
 * Token storage strategy (§13 / CLAUDE.md invariant):
 *   - Access token  → in-memory only (module-level variable). Never localStorage.
 *   - Refresh token → HTTP-only cookie set by the backend /auth/refresh endpoint.
 *
 * This module is the ONLY place that reads/writes the in-memory access token.
 * All other code uses getAccessToken() / setAccessToken() — never touches the variable directly.
 */

let _accessToken: string | null = null;

/** Return the current in-memory access token (may be null if not authenticated). */
export function getAccessToken(): string | null {
  return _accessToken;
}

/** Store a new access token in memory after a successful login or token refresh. */
export function setAccessToken(token: string): void {
  _accessToken = token;
}

/** Clear the in-memory access token on logout. */
export function clearAccessToken(): void {
  _accessToken = null;
}

/** Return true if an access token is currently held in memory. */
export function isAuthenticated(): boolean {
  return _accessToken !== null;
}
